import { useMutation } from '@tanstack/react-query';
import { api } from '@app/utils/api';
import { errorHandler } from '@app/utils/errorHandler';
import { ISelectOption } from '@widgets/multi-select';
import { BI_BASE_URL } from '@app/contstants/endpoints';

interface IManagerFilter {
  managers: {
    id: number;
    first_name: string;
  }[];
}

export const fetchData = async (): Promise<ISelectOption[]> => {
  const response = await api.get<IManagerFilter>(`${BI_BASE_URL}/helpers/managers`);
  const data = response.data ?? [];

  return data.managers.map(item => ({
    value: `${item.id}`,
    label: item.first_name,
  }));
};

export const useManagerOptions = () => {
  const { mutateAsync, isError, isPending, isSuccess, error } = useMutation({
    mutationFn: fetchData,
    onError: error => errorHandler(error),
  });

  return {
    fetchData: mutateAsync,
    isError,
    isPending,
    isSuccess,
    error,
  };
};
